var initializeTabSlidesBlock = function(block){

	jQuery(".accordion .header", block).click(function(){
		
		var index = jQuery(this).parent().index();
		
		changeAccordion(index, block);
		changeImage(index, block);
		
	});
	
	jQuery(".image-slides .image", block).click(function(){
		
		var index = jQuery(this).index();
		
		changeAccordion(index, block);
		changeImage(index, block);
		
	});

}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-tab-slides').each(function(){
		initializeTabSlidesBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=tab-slides', initializeTabSlidesBlock);


function changeAccordion(index, block) {
	
	var currentRow = jQuery('.accordion .row:eq(' + index + ')', block);
	var closeOnly = false;
	
	if(currentRow.hasClass("active"))
		return false;
		
	var parent = currentRow.parents(".accordion");
	var previousSelected = jQuery(".active", parent).removeClass("active");	
	
	jQuery('.content', previousSelected).slideToggle(300);
	
	if(!closeOnly){
		currentRow.toggleClass('active');
		jQuery('.content', currentRow).slideToggle(300);
	}
	
}

function changeImage(index, block) {
	
	jQuery(".image-slides .image.active", block).removeClass('active');
	jQuery(".image-slides .image:eq(" + index + ")", block).addClass('active');
	
}